<template>
    <v-dialog v-model="show" max-width="600px">
        <v-toolbar color="#00ba57" dark>
            <v-toolbar-title class="toolbar-title">Реферальнaя ссылка</v-toolbar-title>
        </v-toolbar>
        <v-card>
            <v-card-text>
                <v-container>
                    <v-form ref="linkForm">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="linkValue"
                                    label="URL"
                                    validate-on-blur
                                    :rules="[rules.required, rules.http]"
                                />
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" flat
                       @click.stop="show = false">Закрыть</v-btn>
                <v-btn class="submit-button block"
                       @click.stop="onSave">Сохранить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ReferralLinkDialog",
    props: ['value', 'id', 'link', 'lastId'],
    data: () => ({
        linkValue: '',
        rules: {
            required: v => !!v || 'Обязательное поле',
            http: v => /https?:\/\/.+/.test(v) || 'Ссылка должна начинаться с http:// или https://',
        }
    }),
    created() {
        this.linkValue = this.link;
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    watch: {
        show(val) {
            if (!val) {
                this.linkValue = '';
            }
        }
    },
    methods: {
        onSave() {
            if (this.$refs.linkForm.validate()) {
                this.link = this.linkValue;
                this.$emit('save', {id: ++this.lastId, link: this.link, uuid: null});
                this.show = false;
            }
        }
    }
}
</script>

<style scoped>
    .toolbar-title {
        font-family: 'SFProBold';
        font-size: 20px;
    }

    .submit-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 18px !important;
        text-transform: none !important;
        box-shadow: none !important;

        height: 56px;
        background-color: #00ba57 !important;;
        text-align: center;
        vertical-align: middle;
        padding: 0 !important;
        margin: 0 5px;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    .submit-button >>> .v-btn__content {
        white-space: pre-wrap;
        padding: 0 30px;
        line-height: 1.1;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/profile/ReferralLinkDialog.vue